import classnames from 'classnames';

import { ActionBlock } from './ActionBlock';
import { CommentBlock } from './CommentBlock';
import { IconBlock } from './IconBlock/IconBlock';
import { InputBlock } from './InputBlock/InputBlock';
import { ListBlock } from './ListBlock/ListBlock';
import { MessageBlock } from './MessageBlock';
import styles from './Modal.module.scss';
import { Title } from './Title';
import { Variance } from './Variance';

export interface ModalProps {
  testId?: string;
  id?: string;
  minWidth?: string;
  className?: string;
  rounded?: boolean;
  children?: React.ReactNode;
}

export const Modal = ({
  testId,
  id,
  minWidth = '33rem',
  className,
  rounded,
  children,
}: ModalProps) => {
  return (
    <div data-testid={testId} className={styles.outerContainer}>
      <div id={id} className={classnames(styles.positionAndSizing, rounded && styles.rounded)}>
        <div
          className={classnames(styles.flexAndBackground, className)}
          style={{ minWidth: minWidth }}>
          <div className={styles.flexColumn}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
export {
  IconBlock,
  Title,
  Variance,
  MessageBlock,
  InputBlock,
  CommentBlock,
  ActionBlock,
  ListBlock,
};
